const s=new CSSStyleSheet();s.replaceSync(JSON.parse("\":host {\\n  display: block;\\n}\\n\""));export default s;